<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat>
					<v-card-text class="pb-0 pt-2">
						<v-row class="pb-1">
							<v-col class="d-flex justify-start pa-0 pl-2">
								<v-btn color="primary" @click="addClick">
									<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
								</v-btn>
							</v-col>
							<v-col class="d-flex justify-center pb-0 pt-0">
								<v-card-title class="text-center pa-2 pb-2 pt-0">
									{{ $t('modules.classrooms') }}</v-card-title
								>
							</v-col>
							<v-col></v-col>
						</v-row>
						<v-row>
							<v-col class="pb-0 pt-0">
								<TheTable
									:additional-filters="classroomsTable.additionalFilters"
									:default-sort="classroomsTable.defaultSort"
									:excel="true"
									:fields="classroomsTable.headers"
									:header-selection-key="'classrooms-headers'"
									:height="classroomsTable.height"
									:total-records="classroomsTable.total"
									:filter-save-key="'classrooms-filters'"
									@excel="excelExport"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in classroomsTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
										@contextmenu.prevent="editClick(props.item.id, true)"
									>
										<td
											v-if="classroomsTable.selectedHeaders.includes('id')"
											@click="editClick(item.id, false)"
										>
											{{ item.id }}
										</td>
										<td
											v-if="classroomsTable.selectedHeaders.includes('name')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.name }}</b>
										</td>
										<td
											v-if="classroomsTable.selectedHeaders.includes('office_id')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.office.name }}</b>
										</td>
										<td
											v-if="classroomsTable.selectedHeaders.includes('capacity')"
											@click="editClick(item.id, false)"
										>
											{{ item.capacity }}
										</td>
										<td
											v-if="classroomsTable.selectedHeaders.includes('active')"
											@click="editClick(item.id, false)"
										>
											<v-icon v-if="item.active" small>fa-check</v-icon>
										</td>
										<td>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														small
														v-bind="attrs"
														@click="editClick(item.id, true)"
														v-on="on"
													>
														<v-icon small>fa-external-link-alt</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('tooltips.openInNewTab') }}</span>
											</v-tooltip>
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'Classrooms',
	components: { TheTable },
	data: function () {
		return {
			classroomsTable: {
				selectedHeaders: [],
				headers: [
					{ text: this.$t('fields.id'), value: 'id', type: 'string', width: '60px', allowFilter: true },
					{ text: this.$t('fields.name'), value: 'name', type: 'string', allowFilter: true },
					{
						text: this.$t('fields.office'),
						value: 'office_id',
						type: 'dropdown|offices',
						allowFilter: true,
					},
					{ text: this.$t('fields.capacity'), value: 'capacity', type: '', allowFilter: true },
					{
						text: this.$t('fields.active'),
						value: 'active',
						type: 'boolean',
						width: '100px',
						allowFilter: false,
					},
					{ text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false },
				],
				additionalFilters: [{ text: this.$t('fields.capacity'), value: 'capacity', type: 'price_range' }],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'name',
					descending: true,
				},
			},
		};
	},
	methods: {
		addClick() {
			this.$router.push('/classrooms/0');
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/classrooms/' + id);
			} else {
				let routeData = this.$router.resolve('/classrooms/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		selectHeaders(headers) {
			this.classroomsTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.classroomsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'classrooms',
				request,
				(data, success) => {
					if (success) {
						vm.classroomsTable.items = data.items;
						vm.classroomsTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.classroomsTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'classrooms',
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/classrooms', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.classroomsTable.height = window.innerHeight - 243 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.classrooms'), href: '/#/classrooms', disabled: true },
		]);

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
